<div class="notch-card">
  <span class="notch" [style.background]="notchColor"></span>
  <div class="body">
    @if (title) {
      <div class="header">
        <span class="title">{{ title }}</span>
        @if (source) {
          <span class="source">{{ source }}</span>
        }
      </div>
    }
    <ng-content></ng-content>
  </div>
</div>
